export default "__VITE_ASSET__BKITFXQZ__"